export default __webpack_public_path__ + "static/media/_download-icon.b5bc1daa.svg";